export default "__VITE_ASSET__BhTes3VN__"